import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { useMemo } from "react";
// import "./App.css";

const Location = () => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: 'AIzaSyBBY_V-zEIdDpr5ffxGLwn62Rcd91WFp-E'
  });
  const center = useMemo(() => ({ lat:6.8685, lng: 79.9255 }), []);

  return (
    <div className="App">
      {!isLoaded ? (
        <h1>Loading...</h1>
      ) : (
        <GoogleMap
          mapContainerClassName="map-container"
          center={center}
          zoom={10}
        >
          <Marker position={{ lat: 6.8685, lng: 79.9255 }} />
        </GoogleMap>
      )}
    </div>
  );
};

export default Location;